/*
 * @Author: xianghongai@gmail.com
 * @Date: 2017-11-09 15:52:17
 * @Last Modified by: Nicholas Hsiang
 * @Last Modified time: 2018-06-21 10:30:19
 */


/* 依赖 Cookies: https://github.com/js-cookie/js-cookie */
var hs = hs || {};

// 需要传入参数: 触发控件/cookie名/计数时间(可选，默认60)
hs.GetSMS = function(param) {
    param = param || {};
    this._timeCount = 0;
    this.item = param.item || '.j_get_sms';
    this.cookieName = param.cookieName;
    this.validTime = param.validTime || 60;
    this.i18n = param.i18n || {
        normal: '获取验证码',
        progress: '重新发送'
    };
};

hs.GetSMS.prototype._countDownTime = function($item) {
    var _this = this;
    _this._timeCount = Cookies.get(_this.cookieName);
    if (_this._timeCount < 1) {
        $item.removeClass("get-sms-disabled get-sms-doing");
        $item.html(_this.i18n.normal);
        return;
    } else {
        $item.html(_this.i18n.progress + "(" + _this._timeCount + ")");
        _this._timeCount--;
        Cookies.set(_this.cookieName, _this._timeCount, {
            expires: _this._timeCount + 1
        });
    }
    setTimeout(function() {
        _this._countDownTime($item);
    }, 1000);
};

hs.GetSMS.prototype.sendSMS = function() {
    var _this = this;
    var $item = $(_this.item);

    // 没有前一次操作记录，当前获取按钮是可用的
    if (_this._timeCount === 0) {
        _this._timeCount = _this.validTime;
        Cookies.set(_this.cookieName, this.validTime, {
            expires: this.validTime
        });
        $item.addClass("get-sms-disabled get-sms-doing");
        _this._countDownTime($item);
    }
};

hs.GetSMS.prototype.sendSMSInit = function() {
    var _this = this;
    var $item = $(_this.item);
    // 进入页面, 如果前一次获取短信验证未操作完,在原来基础上继续操作
    _this._timeCount = Cookies.get(_this.cookieName);
    _this._timeCount = _this._timeCount ? _this._timeCount : 0;
    if (_this._timeCount > 0) {
        $item.addClass("get-sms-disabled get-sms-doing");
        _this._countDownTime($item);
    } else {
        Cookies.set(_this.cookieName, 0, {
            expires: 0
        });
    }
};

